import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { color, fontSize, lineHeight, space, textAlign } from 'styled-system';

const UnstyledCommentValue = styled.div<any>`
  ${color};
  ${fontSize};
  ${lineHeight};
  ${space};
  ${textAlign};
`;

const CommentValue = (props: ComponentProps<typeof UnstyledCommentValue>) => (
  <UnstyledCommentValue
    color="sys.neutral.border.hover"
    fontSize={['fs_14', null, 'fs_16', 'fs_18']}
    lineHeight={['lh_20', null, 'lh_22', 'lh_24']}
    mt={['sp_4', 'sp_0']}
    textAlign="left"
    {...props}
  />
);
export default CommentValue;
